module.exports = __webpack_public_path__ + "img/splash_screen_background.477c46c5.jpg";